import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Button } from '@components/Button';
import { themeSpace, themeVariant, themeColor } from '@utils/styledTheme.util';
import { MediumBoldTextStyles, ButtonTextStyles } from '@components/typography/interVariants';

const FORM_MAX_WIDTH = 445;

export const FormGroup = styled(Box)`
  text-align: left;
  max-width: ${FORM_MAX_WIDTH}px;
  input {
    width: 100%;
  }
`;

export const StyledLabel = styled.label`
  display: block;
  color: #000000;
  font-weight: 600;
  margin-bottom: ${themeSpace(4)};
  ${themeVariant('featureHed20')};
  ${MediumBoldTextStyles};
`;

export const StyledButton = styled(Button)<{ disabled: boolean }>`
  &:disabled {
    cursor: not-allowed;
    outline: none;
    background-color: ${themeColor('mono4')};
    color: ${themeColor('mono2')};
  }

  width: 100%;
  max-width: ${FORM_MAX_WIDTH}px;
  height: 56px;
  ${ButtonTextStyles};
`;
